<template>
    <div>
        <div v-if="canShowContent">
            <Content :content="content" model="section" :api-key="apiKey" :data="categoryData" />
        </div>
    </div>
</template>
<script>
const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY
import { Content, fetchEntries, fetchOneEntry, isPreviewing } from '@builder.io/sdk-vue'

export default {
    name: 'CategoryBottomBlockContent',
    components: {
        Content,
    },
    props: ['categoryId', 'content', 'categoryData'],
    data: () => ({
        apiKey,
    }),
    computed: {
        canShowContent() {
            return (!!this.content && !!this.categoryData) || isPreviewing()
        },
    },
    mounted() {},
}
</script>
<style lang="scss"></style>
